import axios from "axios";
import { refreshAccessToken } from "./authutil";

// Create an Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,// "http://127.0.0.1:8000/api", // Change this to your backend URL
 // withCredentials: true,
});

//  Request Interceptor - Attach JWT Token to Every Request
api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor - Handle 401 and Refresh Token
api.interceptors.response.use(
  (response) => response, // If the response is successful, return it
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Token expired, refreshing...");
      try {
        const newToken = await refreshAccessToken(); // Refresh token function
        if (newToken) {
          error.config.headers.Authorization = `Bearer ${newToken}`;
          return api.request(error.config); // Retry original request
        }
      } catch (refreshError) {
        console.error("Refresh token failed", refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
